// extracted by mini-css-extract-plugin
export default {"PageBreak":"_PageBreak--Pyv40"};